import { PartnerAccumulationDoubt } from "./PartnerAccumulationDoubt";
import { PartnerInfoCard } from "./PartnerInfoCard";
import { InformativeAccumulationPartnerProps } from "./types";

export const InformativeAccumulationPartner: React.FC<InformativeAccumulationPartnerProps> = ({ logo, accumulationPartner, partnerName }) => {
  return (
    <>
      <PartnerInfoCard
        name={partnerName}
        title={accumulationPartner?.banner?.title}
        description={accumulationPartner?.banner?.description}
        logo={logo}
        image={accumulationPartner?.banner?.image}
        url={accumulationPartner?.banner?.buttonLink}
        buttonTitle={accumulationPartner?.banner?.buttonText}
        backgroundColor={accumulationPartner?.banner?.bgColor}
        textColor={accumulationPartner?.banner?.textColor}
        buttonColor={accumulationPartner?.banner?.buttonColor}
      />
      <PartnerAccumulationDoubt
        title={accumulationPartner?.partnerFaq?.title}
        description={accumulationPartner?.partnerFaq?.description}
        listQuestionsAnswer={accumulationPartner?.partnerFaq?.questionsAndAnswerList}
      />
    </>
  );
};
